module.exports = __webpack_public_path__ + "img/main.43a6900f.png";